import { Form } from '@amzn/storm-ui-column-form-kit';
import { InlineAlert } from '@amzn/storm-ui';

import { useCreateDetailedBookingIMPForm } from '../hooks/useCreateDetailedBookingIMPForm';
import { CreateDetailedBookingIMPFormProps } from '../interface/DetailedBookingInterface';
import ContextualNodesSectionIMP from './IMPFormComponents/ContextualNodesSectionIMP';
import IMPMainForm from './IMPFormComponents/IMPMainForm';
import ImpressionsBlockedFieldIMP from './IMPFormComponents/ImpressionsBlockedFieldIMP';
import StatusModal from './IMPFormComponents/StatusModal';

const CreateDetailedBookingIMPForm = (
  props: CreateDetailedBookingIMPFormProps
) => {
  const {
    formData,
    fieldErrors,
    showErrorModal,
    errorModalProps,
    impMainFormProps,
    hasValidationBeenTriggered,
    contextualNodeSectionProps,
    waitlistHintMessage,
  } = useCreateDetailedBookingIMPForm(props);

  return (
    <Form id="detailed-booking-imp-form">
      <IMPMainForm {...impMainFormProps} />
      {formData.slotForGP && (
        <>
          <ContextualNodesSectionIMP {...contextualNodeSectionProps} />
          {waitlistHintMessage && (
            <InlineAlert variant="info" message={waitlistHintMessage} />
          )}
          <ImpressionsBlockedFieldIMP
            hasValidationBeenTriggered={hasValidationBeenTriggered}
            fieldErrors={fieldErrors}
            impressionsBlockedOverContextualNodeValue={formData.impressionsBlockedOverContextualNode.toString()}
          />
        </>
      )}
      {showErrorModal && <StatusModal {...errorModalProps} />}
    </Form>
  );
};

CreateDetailedBookingIMPForm.displayName = 'CreateDetailedBookingIMPForm';

export default CreateDetailedBookingIMPForm;
